export default __webpack_public_path__ + "static/media/ISMO CLASS-1 EXAM PATTERN 2026-27.bd20a7a7.pdf";